var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: [_vm.iconClass, "vue-icon"] },
    [
      _vm.name === "add" ? _c("addIcon") : _vm._e(),
      _vm._v(" "),
      _vm.name === "more-vert" ? _c("moreVert") : _vm._e(),
      _vm._v(" "),
      _vm.name === "dustbin" ? _c("dustbinIcon") : _vm._e(),
      _vm._v(" "),
      _vm.name === "settings" ? _c("settingsIcon") : _vm._e(),
      _vm._v(" "),
      _vm.name === "message" ? _c("messageIcon") : _vm._e(),
      _vm._v(" "),
      _vm.name === "clip" ? _c("clipIcon") : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }